import { Category } from '../types';

export const categories: Category[] = [
  {
    id: 'wedding',
    title: 'Bodas',
    description: 'Capturamos los momentos más especiales de tu boda.',
    query: 'wedding photography'
  },
  {
    id: 'family',
    title: 'Familiares',
    description: 'Fotografías que atesoran los recuerdos familiares.',
    query: 'family portrait'
  },
  {
    id: 'business',
    title: 'Negocios',
    description: 'Imágenes profesionales para tu marca o negocio.',
    query: 'business portrait'
  },
  {
    id: 'editorial',
    title: 'Moda Editorial',
    description: 'Fotografía para revistas y campañas de moda.',
    query: 'fashion editorial'
  },
  {
    id: 'portraits',
    title: 'Retratos',
    description: 'Retratos artísticos y personales.',
    query: 'portrait photography'
  },
  {
    id: 'events',
    title: 'Eventos',
    description: 'Cobertura de eventos sociales y culturales.',
    query: 'event photography'
  },
  {
    id: 'advertising',
    title: 'Publicidad',
    description: 'Fotografía para campañas publicitarias.',
    query: 'advertising photography'
  },
  {
    id: 'beauty',
    title: 'Belleza',
    description: 'Fotografía de maquillaje, peinados y estilismo.',
    query: 'beauty photography'
  },
  {
    id: 'sports',
    title: 'Deportes',
    description: 'Fotografía deportiva y de actividad física.',
    query: 'sports photography'
  },
  {
    id: 'nature',
    title: 'Naturaleza',
    description: 'Fotografía de moda en exteriores y paisajes.',
    query: 'nature fashion photography'
  }
];